import styled from 'styled-components'

import { Icon } from '~design-system'

const NavIcon = styled(Icon).attrs({ color: 'greyDarker', size: 'medium' })``

export default NavIcon
